import { useNavigate } from "react-router";
import { ShieldAlert } from "lucide-react";

import { PATHS } from "@/routes/paths";

export function AcessoNegado() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-full gap-6 p-6 text-center">
      <ShieldAlert className="h-20 w-20 text-[#034065]" strokeWidth={1.5} />
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-semibold text-[#15181E]">
          Acesso negado
        </h1>
        <p className="text-sm text-gray-500 max-w-sm">
          Você não tem permissão para realizar esta ação.
        </p>
      </div>
      <button
        onClick={() => navigate(PATHS.dashboard)}
        className="px-5 py-2.5 bg-[#034065] text-white rounded-lg text-sm font-medium hover:bg-[#B89B3C] transition-colors"
      >
        Voltar ao Dashboard
      </button>
    </div>
  );
}
